import React, { useEffect, useState } from "react";
import { Link,useHistory } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import axios from "axios";

// Import required modules
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const Cart = () => {
    const [cart, setCart] = useState([]);
    const history = useHistory()

  // Load from localStorage when component mounts
  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(storedCart);
  }, []);

  // ✅ Update quantity
  const updateQuantity = (id, newQty) => {
   let updatedCart = cart.map((item) =>
      item.id === id ? { ...item, quantity: Math.max(1, newQty) } : item
    );
    setCart(updatedCart);
      localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  // ✅ Remove item from cart
  const removeFromCart = (id) => {
    let updatedCart = cart.filter((item) => item.id !== id);
    setCart(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  // ✅ Clear entire cart
  const clearCart = () => {
    setCart([]);
     localStorage.clear();
  };

  // ✅ Subtotal calculation
  const subtotal = cart.reduce(
    (sum, item) => sum + 100 * item.quantity,
    0
  );

  const handleCart =() =>{
   history.push("/checkout")
  }

    // console.log("cart_data",cart_detail);
    return (
    <main className="main-content site-wrapper-reveal">
    {/* <!--== Start Page Title Area ==--> */}
    <section className="page-title-area" data-bg-img="assets/img/photos/bg-page-title.webp" style={{backgroundColor: "gray"}}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="page-title-content text-center">
              <h2 className="title text-white">YOUR SHOPPING CART</h2>
              <div className="bread-crumbs"><Link to="/">Home<span className="breadcrumb-sep">/</span></Link><span className="active">Your Shopping Cart</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* <!--== End Page Title Area ==--> */}

    {/* <!--== Start Cart Area Wrapper ==--> */}
    <section className="cart-page-area">
      <div className="container pt-100 pb-100">
        <div className="row">
          <div className="col-12">
            <div className="cart-table table-responsive">
              <table>
                <thead>
                  <tr>
                    <th className="pro-thumbnail">Image</th>
                    <th className="pro-title">Product</th>
                    <th className="pro-price">Price</th>
                    <th className="pro-quantity">Quantity</th>
                    <th className="pro-subtotal">Total</th>
                    <th className="pro-remove">Remove</th>
                  </tr>
                </thead>
                <tbody>
                  {cart.map((element) => (
                    
                    <tr key={element.id}>
                      <td className="pro-thumbnail" >
                        <img
                          src={`https://sachiproduct-backend.theaditech.in/${element.image}`}
                          alt={element.name}
                          style={{ width: "80px" }}
                        />
                      </td>
                      <td className="pro-title">
                        <h4>{element.name}</h4>
                      </td>
                      <td className="pro-price">
                        <span>$100</span>
                      </td>
                      <td className="pro-quantity">
                        <div className="quick-product-action">
                          <div className="pro-qty">
                            <button
                              onClick={() =>
                                updateQuantity(element.id, element.quantity - 1)
                              }
                            >
                              -
                            </button>
                            <input
                              type="text"
                              value={element.quantity}
                              readOnly
                            />
                            <button
                              onClick={() =>
                                updateQuantity(element.id, element.quantity + 1)
                              }
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </td>
                      <td className="pro-subtotal">
                        <span>${(100 * element.quantity).toFixed(2)}</span>
                      </td>
                      <td className="pro-remove">
                        <button onClick={() => removeFromCart(element.id)}>×</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="col-12">
            <div className="cart-buttons">
              <Link className="btn-shopping" to="/product">
                Continue Shopping
              </Link>
              <button className="btn-shopping" onClick={clearCart}>
                Clear Cart
              </button>
            </div>
          </div>

          <div className="col-12">
            <div className="cart-payment">
              <div className="cart-subtotal">
                <h3 className="title">Cart Totals</h3>
                <table>
                  <tbody>
                    <tr className="cart-subtotal">
                      <th>Subtotal</th>
                      <td>
                        <span className="amount">${subtotal.toFixed(2)}</span>
                      </td>
                    </tr>
                    <tr className="order-total">
                      <th>Total</th>
                      <td>
                        <span className="price">${subtotal.toFixed(2)}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <button className="btn-theme" onClick={() => handleCart()}>
                  Proceed to Checkout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* <!--== End Cart Area Wrapper ==--> */}
  </main>
    )
}
export default Cart